export default {"src":"/customer-services/_next/static/media/chat.e767a7fe.svg","height":20,"width":25,"blurWidth":0,"blurHeight":0};